/**
 * This function returns the license status
 * to the user if license is either going to expire soon or has expired
 */
export function fetchLicenseInfo(licenseExpiryDays: number): string | undefined {
  let licenseValidityStatus: string | undefined;
  if (licenseExpiryDays >= 7 && licenseExpiryDays <= 15) {
    licenseValidityStatus = 'warning';
  } else if (licenseExpiryDays >= 0 && licenseExpiryDays < 7) {
    licenseValidityStatus = 'severe';
  } else if (licenseExpiryDays < 0) {
    licenseValidityStatus = 'error';
  }

  return licenseValidityStatus;
}
